import { Component } from "react";
import Uppy from '@uppy/core'
import { DashboardModal } from '@uppy/react'
import Transloadit from '@uppy/transloadit';
import GoogleDrive from '@uppy/google-drive';
import Instagram from '@uppy/instagram';
import Url from '@uppy/url';
import Webcam from '@uppy/webcam';
import $ from 'jquery'
import ReactHtmlParser from 'react-html-parser';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import { VIDEO_COMPRESS } from "../../../../../actions/api";
import axios from 'axios'
import { TOAST_ERROR } from "../../../../../utils";
import { UPPY_AWS_KEY, UPPY_AWS_SECRET_KEY, UPPY_BUCKET, UPPY_BUCKET_URL, UPPY_CAMPAION_URL, UPPY_KEY } from "../../../../../actions/constant";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { Button, Image } from "react-bootstrap";

const requestHeaders = {
    productdomain: `taggbox.com`
}

const uppyKey = UPPY_KEY;
const uppyBucket =  UPPY_BUCKET;
const uppyAwsKey =  UPPY_AWS_KEY;
const uppyAwsSecret =  UPPY_AWS_SECRET_KEY;
const companionUrl = UPPY_CAMPAION_URL;

class ImageUpload extends Component {

    constructor(props) {
        super(props)

        this.uppyPostEdit = new Uppy({

            debug: true,
            autoProceed: true,
            restrictions: {
                maxFileSize: 6000000, maxNumberOfFiles: 1, minNumberOfFiles: 1, allowedFileTypes: ['image/*', 'video/*'],
            },
            onBeforeUpload: (files) => {
                try {


                    const fileKeys = Object.keys(files);


                    if (files[fileKeys[0]].meta.type.includes("image")) {
                        this.remove_StatusBar();
                    }

                    const updateFilesType = files[fileKeys[0]];


                    if (updateFilesType.isRemote == false && fileKeys && fileKeys.length > 0 && files[fileKeys[0]] && files[fileKeys[0]].meta && files[fileKeys[0]].meta.type.includes("video")) {

                        let progressindicators = document.querySelector(".uppy-Dashboard-progressindicators");

                        if(progressindicators){
                            var html_to_insert = '<div class="uppy-StatusBar is-postprocessing"><div class="uppy-StatusBar-progress is-indeterminate" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="100" style="width: 100%;"></div><div class="uppy-StatusBar-content"><svg class="uppy-StatusBar-spinner" aria-hidden="true" focusable="false" width="14" height="14"><path d="M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0" fill-rule="evenodd"></path></svg>Encoding...</div><div class="uppy-StatusBar-actions"><button type="button" class="uppy-u-reset uppy-StatusBar-actionCircleBtn" title="Cancel" aria-label="Cancel" data-uppy-super-focusable="true"><svg aria-hidden="true" focusable="false" class="uppy-c-icon" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd"><circle fill="#888" cx="8" cy="8" r="8"></circle><path fill="#FFF" d="M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"></path></g></svg></button></div></div><div class="uppy uppy-Informer" aria-hidden="true"><p role="alert"> </p></div>';

                            progressindicators.innerHTML = html_to_insert;
                        }

                        $('.uppy-DashboardContent-back,.is-waiting,.uppy-Informer,.uppy-StatusBar-actions,.uppy-Dashboard-Item-action--remove').remove();

                        this.setState({ isLoading: true })
                        const updateFiles = files[fileKeys[0]];

                        const data = new FormData();

                        data.append("file", updateFiles.data);
                        data.append("wallId", localStorage.getItem('wallId'));
                        data.append("ownerId", localStorage.getItem('ownerId'));
                        
                        axios.post(VIDEO_COMPRESS, data, {
                            headers: requestHeaders
                        }).then((response) => {
                            const { responseData } = response.data;
                            if (responseData && responseData.length > 0) {

                                let fname = `<iframe class="vimeoVideo iframeVideo" src="${responseData[0].s3Url}" width="100%" height="350" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`

                                this.setState({ thumb_file: responseData[0].s3ThumbUrl, selectedFile: "", mediaTyp: 'video', filename: fname, selected: responseData[0].s3Url })

                                const { setmediaType, sethumbFile, setmediaWidth, setmediaHeight, setvideoType, setpostImage, setmediaFilePath } = this.props
                                setmediaType('video');
                                sethumbFile(responseData[0].s3ThumbUrl);
                                setmediaWidth(responseData[0].width);
                                setmediaHeight(responseData[0].height);
                                setmediaFilePath(responseData[0].s3Url);
                                setpostImage(fname);
                                setvideoType(0);
                                this.onClickToClose();
                            }
                        }).catch((error) => {
                            this.setState({ thumb_file: "" })
                            if(progressindicators){
                                progressindicators.innerHTML = '<div class="uppy-StatusBar is-postprocessing"><div class="uppy-error"><i class="fas fa-exclamation-circle"></i> something went wrong (Minimum video size more then 5 sec) </div></div>';
                            }
                        })
                        return false;
                    } else if (updateFilesType.isRemote == true) {
                        $(".is-postprocessing").remove();
                        const { sethumbFile } = this.props
                        sethumbFile(updateFilesType.data.thumbnail ? updateFilesType.data.thumbnail : "");
                    }

                } catch (error) {
                    console.log(error, 'errorerrorerror')
                }

            },
        })
            .use(Transloadit, {
                target: '#a',
                params: {
                    auth: {
                        key: uppyKey
                    },
                    steps: {
                        // resize: {
                        //     robot: '/image/resize',
                        //     width: 500,
                        //     resize_strategy: 'fit',
                        //     background: 'none',
                        // },
                        store: {
                            robot: "/wasabi/store",
                            bucket_region: "us-west-1",
                            bucket: uppyBucket,
                            key: uppyAwsKey,
                            secret: uppyAwsSecret,
                            path: 'media/tmpimages/${file.id}.${file.ext}'
                        },

                    }
                },
                waitForEncoding: true
            })
            .use(Instagram, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(GoogleDrive, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(Url, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(Webcam, { target: Uppy.Dashboard, companionUrl: companionUrl })

            .on("restriction-failed", (file, error) => {

                let fileType = file.type.split('/');

                if (fileType[0] != 'image' && fileType[0] != 'video') {
                    TOAST_ERROR("You can only upload Image/Video file")
                    return false
                }

                if (file.size > 6000000) {
                    TOAST_ERROR("Maximum allowed size of 5 MB")
                    return false
                }
            })

        this.onClickToOpen = this.onClickToOpen.bind(this)
        this.onClickToClose = this.onClickToClose.bind(this)
    }



    state = {
        filename: null,
        modalOpen: false,
        mediaTyp: null,
        updateFile: 0,
        thumb_file: null,
        selected: ""
    }

    componentDidMount() {

        this.uppyPostEdit.on('transloadit:result', (stepName, result) => {

            const fileKeys = Object.keys(result);

            this.setState({ selectedFile: `${result.id}.${result.ext}`, mediaTyp: result.type, filename: result.type.includes('video') ? `<video width="320" height="210" controls><source src="${`${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`}" />  </video>` : `${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`, selected: `${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}` }, () => {

                const { setmediaType, setmediaSize, setvideoType } = this.props
                setmediaType(result.type);
                setmediaSize(result.meta);

                if (result.type.includes('video')) {
                    let fname = `<video width="320" height="210" controls>
                    <source src="${`${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`}" />
                   </video>`

                    const { setmediaWidth, setmediaHeight, setpostImage, setmediaFilePath } = this.props
                    setmediaWidth(result.meta.width);
                    setmediaHeight(result.meta.height);
                    setmediaFilePath(`${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`);
                    setpostImage(fname);
                    setvideoType(1);
                } else {
                    setvideoType(0);
                }

                setTimeout(() => {
                    this.uppyPostEdit.cancelAll()
                    this.props.onImgUpload(`${result.id}.${result.ext}`)
                    this.setState({ modalOpen: false })
                }, 300)
            })
        })
    }


    setpostFile = (imageName) => {
        this.setState({ filename: imageName, updateFile: 1 })
    }


    onClickToOpen = () => {

        this.setState({ modalOpen: true })
        $(".uppy-Dashboard-close").click(() => {
            this.uppyPostEdit.cancelAll()
            this.setState({ modalOpen: false })
        })

        setTimeout(() => {
            this.updateProgressindicators();
        }, 10)
    }


    updateProgressindicators = () => {
        $(".uppy-Dashboard-progressindicators").remove();
    }


    remove_StatusBar = () => {
        $('.uppy-StatusBar').remove();
    }


    onClickToClose = () => {
        this.uppyPostEdit.cancelAll()
        this.setState({ modalOpen: false })
    }

    componentWillUnmount() {
        this.uppyPostEdit.cancelAll()
        this.uppyPostEdit.close({ reason: 'unmount' })
        this.setState({ modalOpen: false })
    }


    render() {

        const { data, filename, mediaTyp, updateFile, modalOpen, selectedFile } = this.state;
        const { imageName, postImage, onRemovePost, postType, setmediaType, mediaTypeFile } = this.props


        if (imageName && updateFile == 0) {
            this.setpostFile(imageName);
        }


        return (

            <div className="form-group">
                <div className="form-group custom-post_upload-image">
                    <div className="fileinput fileinput-new addProUploder uppy_upload">
                        <div className="fileinput-preview align-content-center d-flex flex-wrap justify-content-center">

                            {filename == null ?
                                <div className="h-100 w-100 cursor-pointer uppy-btn" id="uppyModalOpenerCustom" onClick={() => this.onClickToOpen()}>
                                    <div className="d-flex align-items-center justify-content-center h-100 w-100">
                                       <FontAwesomeIcon type={'solid'} icon={'image'} iconClass="display-1 text-gray-500"/>
                                    </div>
                                </div>
                                :
                                <><div data-provides="fileinput" id="imgUploadBtn">
                                    <div data-trigger="fileinput">
                                        { filename && filename != 'undefined' ? mediaTypeFile && mediaTypeFile != 'content' ? mediaTypeFile == 'image' ? 
                                        <Image id="customPostThumb" className="img-fluid" src={filename} width="318" height="200" alt="" /> : ReactHtmlParser(filename)
                                                    :
                                                    postType == 3 || postType == 5 ?
                                                        ReactHtmlParser(filename)
                                                        :
                                                        <>
                                                            <Image id="customPostThumb" className="img-fluid" src={filename} width="318" height="200" alt="" />
                                                        </>
                                                :
                                                <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                                    <FontAwesomeIcon type={'solid'} icon={'image'} iconClass="display-1 text-gray-500"/>
                                                </div>

                                        }
                                    </div>
                                </div> <input type="hidden" name="data[Post][postFile]" autoComplete="off" className="upload posts0postFilen" id="posts0postFile" />
                                </>
                            }
                        </div>

                        <div className="click_text" >
                            <div className="addIcoSec text-center my-4">

                                <div className="d-flex align-items-center justify-content-center mb-2">
                                    <Button variant="light" id="close-post-upload" onClick={() => this.onClickToOpen()} className="img_uploader_icon uppy-btn rounded-circle f-center">
                                        <FontAwesomeIcon type={'regular'} icon={'plus'} iconClass="fs-4 text-gray-500"/>
                                    </Button>
                                    <Button variant="light" onClick={() => { this.setState({ filename: null }); setmediaType(null); onRemovePost('') }} id="cp_remove_image" className="img_uploader_icon rounded-circle f-center" style={{ display: filename ? 'block' : 'none' }}>
                                        <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass="fs-4 text-gray-500"/>
                                    </Button>
                                </div>

                                <div className="file_uploader_card_txt">
                                    <strong className="text-center text-muted mb-2">Click here</strong>
                                    <span>to upload the new media</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* {modalOpen ? ( */}

                <DashboardModal
                    animateOpenClose={true}
                    proudlyDisplayPoweredByUppy={false}
                    inline={false}
                    showProgressDetails={true}
                    height={750}
                    browserBackButtonClose={true}
                    showRemoveButtonAfterComplete={false}
                    uppy={this.uppyPostEdit}
                    open={modalOpen}
                    onRequestCloseModal={this.onClickToClose}
                    closeAfterFinish={true}
                    doneButtonHandler={this.doneButtonHandler}
                    plugins={["Instagram", "GoogleDrive", "Url", "Webcam"]}
                />
                {/* ) : null} */}
            </div>
        );
    }
}

export default ImageUpload;
